import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import Hotjar from '@hotjar/browser';

if (environment.production) {
  enableProdMode();
  if (environment.hotjarProjectId) {
    const siteId = environment.hotjarProjectId;
    const hotjarVersion = 6;
    Hotjar.init(siteId, hotjarVersion);
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
